<template>
    <Modal
        :value="notifDetailAction !== ''"
        :scrollable="true"
        :mask-closable="false"
        :closable="false"
        :transfer="false"
        width="1008px"
        class-name="new-notif"
        :footer-hide="true"
        @on-cancel="handleCancel">
        <Button class="new-notif__btn btn--close"
                @click="handleCancel"
                shape="circle">关闭</Button>
        <div class="new-notif__body" ref="body">
            <div class="new-notif__header">{{ headerText }}</div>
            <Form :model="formData"
                :rules="rules"
                class="new-notif__form"
                :disabled="formDisabled"
                ref="form">
                <div class="flex new-notif__form__sub">
                    <div class="flex flex--direction-column">
                        <div class="new-notif__form__legend">消息类型</div>
                        <FormItem prop="msgType" style="width: 90px">
                        <Select :value="formData.msgType"
                            placeholder="请选择"
                            @on-change="val => handleMsgTypeSelect(val)"
                            transfer>
                            <Option :value="item.key"
                                    :key="item.key"
                                    v-for="item in [{key: 'MARKETING', value: '营销需求'}, {key: 'MAINTENANCE', value: '系统维护'}]">{{item.value}}</Option>
                        </Select>
                        </FormItem>
                    </div>
                    <div class="flex flex--direction-column" style="margin-left: 8px; flex-grow: 1">
                        <div class="new-notif__form__legend">消息标题</div>
                        <FormItem prop="subject">
                        <Input type="text"
                                class="new-notif__form__subject"
                                element-id="subject"
                                placeholder="输入标题..."
                                v-model="formData.subject" />
                        </FormItem>
                    </div>
                </div>
                <div class="new-notif__form__sub">
                    <div class="new-notif__form__legend">消息内容</div>
                    <FormItem prop="content" class="new-notif__form__content">
                    <Input placeholder="在这里输入正文... "
                            element-id="content"
                            class="new-notif__form__content"
                            type="textarea"
                            v-model="formData.content" />
                    </FormItem>
                </div>
                <div class="new-notif__form__sub">
                    <div class="new-notif__form__legend">消息推送人群</div>
                    <div class="new-notif__form__receivers flex flex--align-center" :style="'border-color: ' + (receiverSearchFocused ? '#7C4DFF' : 'rgba(0, 0, 0, 0.08)')">
                        <my-tag
                            v-for="filter in formData.receiverFilters"
                            :key="filter.key"
                            :text="filter.name"
                            removable
                            :disabled="formDisabled"
                            @remove-tag="toggleReceiverTags(filter.type, filter.key, filter.name, true)"
                            style="margin-bottom: 4px"
                        ></my-tag>
                        <div v-if="formData.receiverFilters.length == 0 && !receiverSearchTerm" class="new-notif__form__receivers__placeholder">选择或输入推送人用户名、手机或者邮箱...</div>
                        <div :contenteditable="formDisabled ? 'false' : 'plaintext-only'"
                            ref="receiverSearch"
                            class="new-notif__form__receivers__input"
                            @input="handleReceiversInput"
                            @focus="handleReceiversFocus"
                            @blur="handleReceiversBlur"
                        ></div>
                        <div class="new-notif__form__receivers__search" :hidden="!receiverSearchTerm">
                            <div v-for="item in userSearchResult" :key="item.id" class="new-notif__form__receivers__search__item" @click="handleSelectUser(item)">
                                <div class="new-notif__form__receivers__search__item__phone">{{ item.phoneStrPre }}<span style="color: #7C4DFF">{{ item.phoneStrHighlight }}</span>{{ item.phoneStrPost }}</div>
                                <div class="new-notif__form__receivers__search__item__other">{{ item.otherStrPre }}<span style="color: #7C4DFF">{{ item.otherStrHighlight }}</span>{{ item.otherStrPost }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex--align-center" style="margin-top: 4px">
                        <my-tag
                            v-for="tag in receiverTags"
                            :text="tag.name"
                            :key="tag.key"
                            @click="toggleReceiverTags('category', tag.key, tag.name)"
                            :disabled="(formData.receiverFilters.find(f => f.key == tag.key && f.type == 'category') != null) || formDisabled"
                        ></my-tag>
                    </div>
                </div>
                <div class="flex flex--justify-between new-notif__form__sub">
                    <div style="margin-right: 16px; flex-grow: 1">
                        <div class="new-notif__form__legend">推送日期</div>
                        <FormItem prop="date">
                        <DatePicker
                            class="new-notif__form__datepicker"
                            transfer
                            :options="startTimeOption"
                            v-model="formData.date"
                            placeholder="请选择日期"></DatePicker>
                        </FormItem>
                    </div>
                    <div style="flex-grow: 1">
                        <div class="new-notif__form__legend">推送时间</div>
                        <FormItem prop="time">
                        <TimePicker
                            class="new-notif__form__timepicker"
                            transfer
                            v-model="formData.time"
                            placeholder="请选择时间"></TimePicker>
                        </FormItem>
                    </div>
                </div>
                <div class="new-notif__form__sub" style="margin-bottom: 42px">
                    <div class="new-notif__form__legend">推送方式</div>
                    <div>
                        <div class="flex flex--align-center" style="margin-bottom: 8px">
                            <Checkbox v-model="formData.via.web" @on-change="handleViaWebChange"></Checkbox>
                            <div class="new-notif__form__pushway flex flex--justify-between" :active="formData.via.web">
                                <div class="flex flex--align-center">
                                    <div class="new-notif__form__pushway__text" style="margin-right: 8px">平台推送</div>
                                    <DatePicker
                                        class="new-notif__form__pushway__datepicker"
                                        v-model="formData.via.indexNotif"
                                        :open="showIndexNotifDatePicker"
                                        :options="indexNotifDateOption"
                                        @on-change="showIndexNotifDatePicker = false"
                                        @on-clickoutside="showIndexNotifDatePicker = false"
                                        transfer
                                    >
                                        <my-tag v-if="!formData.via.indexNotif"
                                            :disabled="!formData.via.web || formDisabled"
                                            color="rgba(0, 0, 0, 0.54)"
                                            :text="showIndexNotifDatePicker ? '选择首页提醒截止日期' : '首页提醒：关闭'"
                                            @click="handleClickIndexNotif"
                                        ></my-tag>
                                        <my-tag v-else
                                            :text="formData.via.indexNotif | formatDate('YYYY-MM-DD')"
                                            @click="handleClickIndexNotif"
                                            :disabled="formDisabled"
                                            @remove-tag="formData.via.indexNotif = ''"
                                            removable
                                        ></my-tag>
                                    </DatePicker>
                                </div>
                                <div class="flex flex--align-center">
                                    <div v-if="formData.via.indexNotif" class="new-notif__form__pushway__icon" style="margin-right: 8px">
                                        <v-icon type="iconpriority_high-24px"></v-icon>
                                    </div>
                                    <div class="new-notif__form__pushway__icon">
                                        <v-icon type="icondevices-24px"></v-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex--align-center" style="margin-bottom: 8px">
                            <Checkbox v-model="formData.via.phone"></Checkbox>
                            <div class="new-notif__form__pushway flex flex--justify-between" :active="formData.via.phone">
                                <div class="new-notif__form__pushway__text">手机短信推送</div>
                                <div class="new-notif__form__pushway__icon">
                                    <v-icon type="iconsms-24px"></v-icon>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex--align-center">
                            <Checkbox v-model="formData.via.email"></Checkbox>
                            <div class="new-notif__form__pushway flex flex--justify-between" :active="formData.via.email">
                                <div class="new-notif__form__pushway__text">电子邮箱推送</div>
                                <div class="new-notif__form__pushway__icon">
                                    <v-icon type="iconemail-24px1"></v-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Button v-if="notifDetailAction !== 'view'" @click.native="handleSubmit"
                    long
                    :disabled="isSubmitDisabled"
                    type="primary"
                    :loading="detailLoading"
                    shape="circle"
                    style="margin-bottom: 58px"
                    id="submitNewNotif">提交</Button>
            </Form>
            <div v-if="notifDetailAction === 'view' && notifDetail.status === 'PENDING' && notifDetail.sender_id === myUserId" class="flex flex--justify-center">
                <Button
                    long
                    type="primary"
                    shape="circle"
                    style="margin-bottom: 58px; width: 128px; margin-right: 64px"
                    @click="handleModifyNotif"
                >修改</Button>
                <Button
                    long
                    type="default"
                    shape="circle"
                    style="margin-bottom: 58px; width: 128px"
                    @click="handleDeleteNotif"
                >删除</Button>
            </div>
        </div>
    </Modal>
</template>
<script>
import moment from 'moment';
import MyTag from "./MyTag.vue";
import { fuzzySearch } from "@/api/user/user.js";
import { mapState, mapActions } from "vuex";
import { debounce } from "lodash";

import { ROLE_MAPPING } from "@/assets/staticData/NotificationMapping.js";

export default {
    name: "new-notif-card",
    components: {
        MyTag,
    },
    data() {
        const validatePushTime = (rule, value, callback) => {
            const ts = this.formData.date;
            if (this.formData.time instanceof Date) {
                ts.setHours(this.formData.time.getHours());
                ts.setMinutes(this.formData.time.getMinutes());
                ts.setSeconds(this.formData.time.getSeconds());
            } else {
                const hms = this.formData.time.split(':');
                ts.setHours(parseInt(hms[0]));
                ts.setMinutes(parseInt(hms[1]));
                ts.setSeconds(parseInt(hms[2]));
            }
            if (ts.valueOf() <= moment().add(5, 'minute').valueOf())
                callback(new Error('请选择从现在起至少五分钟后推送'));
            else
                callback();
        };

        return {
            formData: {
                via: {
                    web: false,
                    email: false,
                    phone: false,
                    indexNotif: ''
                },
                receiverFilters: [],
            },
            rules: {
                subject: [{
                    max: 20,
                    message: '标题长度不能超过20个字符'
                }],
                content: [{
                    max: 200,
                    message: '内容长度不能超过200个字符'
                }],
                time: [
                    { validator: validatePushTime, trigger: 'blur' },
                ]
            },
            startTimeOption: {
                disabledDate(date) {
                    return date && date.valueOf() < moment().startOf('day').valueOf();
                },
            },
            indexNotifDateOption: {
                disabledDate(date) {
                    return date && (date.valueOf() < moment().startOf('day').valueOf() || date.valueOf() > moment().add(15, 'day').startOf('day').valueOf());
                }
            },
            receiverTags: [
                {
                    name: '商务',
                    key: 'business'
                },
                {
                    name: '主管',
                    key: 'director'
                },
                {
                    name: '财务',
                    key: 'financial'
                },
                {
                    name: '客户',
                    key: 'customer'
                }
            ],
            showIndexNotifDatePicker: false,
            userSearchResult: [],
            receiverSearchTerm: '',
            receiverSearchFocused: false
        }
    },
    computed: {
        ...mapState("notification", ["notifDetail", "notifDetailAction", "detailLoading"]),
        ...mapState("user", {
            myUserId: "id"
        }),
        headerText() {
            switch (this.notifDetailAction) {
                case 'view':
                    return '消息详情';
                case 'modify':
                    return '修改消息';
                case 'new':
                    return '新消息';
                default:
                    return '新消息';
            }
        },
        formDisabled() {
            return this.notifDetailAction === 'view';
        },
        isSubmitDisabled() {
            return !(this.formData.msgType
                && this.formData.subject
                && this.formData.content
                && this.formData.receiverFilters.length > 0
                && this.formData.date
                && this.formData.time
                && (this.formData.via.web || this.formData.via.phone || this.formData.via.email)
                );
        },
    },
    methods: {
        ...mapActions({
            setToModify: "notification/setToModify",
            setToBeDeleted: "notification/setToBeDeleted",
            resetNotifDetail: "notification/resetNotifDetail",
            createOrUpdateNotif: "notification/createOrUpdateNotif",
        }),
        handleCancel() {
            this.resetNotifDetail();
        },
        handleMsgTypeSelect(val) {
            this.formData.msgType = val;
        },
        async handleSubmit() {
            const valid = await this.$refs.form.validate();
            if (valid) {
                this.createOrUpdateNotif({ formData: this.formData});
            } else {
                this.$Message.error('请修改出现红色提示框中的内容');
            }
        },
        toggleReceiverTags(type, key, name, forceRemove=false) {
            let idx = this.formData.receiverFilters.findIndex(f => f.type === type && f.key === key);
            if (idx > -1)
                this.formData.receiverFilters.splice(idx, 1);
            else if (!forceRemove)
                this.formData.receiverFilters.push({ type, key, name });
        },
        handleReceiversInput: debounce(async function(e) {
            this.receiverSearchTerm = this.$refs.receiverSearch.innerHTML;
            const res = await fuzzySearch(this.receiverSearchTerm);
            const included = this.formData.receiverFilters.filter(item => item.type === 'user').map(item => item.key);
            this.userSearchResult = res.filter(item => included.indexOf(item.id) === -1);
            this.userSearchResult.forEach(item => {
                const phoneStr = item.phone.toString();
                const otherStr = `用户名: ${item.full_name} | Email: ${item.email}`;
                const phoneMatchIdx = phoneStr.indexOf(this.receiverSearchTerm);
                const otherMatchIdx = otherStr.indexOf(this.receiverSearchTerm);
                item.phoneStrPre = '';
                item.phoneStrHighlight = '';
                item.phoneStrPost = phoneStr;
                if (phoneMatchIdx > -1) {
                    item.phoneStrPre = phoneStr.substring(0, phoneMatchIdx);
                    item.phoneStrHighlight = this.receiverSearchTerm;
                    item.phoneStrPost = phoneStr.substring(phoneMatchIdx + this.receiverSearchTerm.length);
                }
                item.otherStrPre = '';
                item.otherStrHighlight = '';
                item.otherStrPost = otherStr;
                if (otherMatchIdx > -1) {
                    item.otherStrPre = otherStr.substring(0, otherMatchIdx);
                    item.otherStrHighlight = this.receiverSearchTerm;
                    item.otherStrPost = otherStr.substring(otherMatchIdx + this.receiverSearchTerm.length);
                }
            });
        }, 500),
        handleViaWebChange(val) {
            if (!val)
                this.formData.via.indexNotif = '';
        },
        handleClickIndexNotif() {
            this.showIndexNotifDatePicker = !this.showIndexNotifDatePicker;
        },
        handleSelectUser(user) {
            this.formData.receiverFilters.push({
                type: 'user',
                key: user.id,
                name: user.phone
            });
            // clear search input
            this.receiverSearchTerm = '';
            this.$refs.receiverSearch.innerHTML = '';
            this.$refs.receiverSearch.focus();
        },
        handleReceiversFocus() {
            this.receiverSearchFocused = true;
        },
        handleReceiversBlur() {
            this.receiverSearchFocused = false;
        },

        resetFormData() {
            this.formData = {
                via: {
                    web: false,
                    email: false,
                    phone: false,
                    indexNotif: ''
                },
                receiverFilters: [],
            }
            this.$refs.form.fields.forEach(f => f.resetField());
        },
        setFormData(src) {
            this.resetFormData();
            if (!src) return;
            this.formData.msgType = src.type;
            this.formData.subject = src.subject;
            this.formData.content = src.content;
            this.formData.type = src.type;
            this.formData.date = src.timestamp;
            this.formData.time = src.timestamp;
            this.formData.via.web = src.viaWeb;
            this.formData.via.email = src.viaEmail;
            this.formData.via.phone = src.viaPhone;
            src.receiversCategory.forEach(c => {
                this.formData.receiverFilters.push({
                    type: 'category',
                    key: c,
                    name: ROLE_MAPPING[c]
                });
            });
            src.receiversUsers.forEach(u => {
                this.formData.receiverFilters.push({
                    type: 'user',
                    key: u.id,
                    name: u.phone
                });
            })
            if (src.indexNotif)
                this.formData.via.indexNotif = src.indexNotif;
        },
        handleModifyNotif() {
            this.setToModify({ notification: this.notifDetail });
        },
        handleDeleteNotif() {
            this.setToBeDeleted({ notification: this.notifDetail });
        }
    },
    watch: {
        notifDetailAction(val) {
            this.$refs.body.scrollTop = 0;
            this.setFormData(this.notifDetail);
        },
    }
}
</script>
<style lang="less">
    .new-notif {
        
        .ivu-modal{
            max-width: 1008px;
            top: 112px;
            position: relative;
        }

        .ivu-modal-body {
            padding: 0;
        }

        &__btn {
            position: absolute;
            width: 88px;
            &.btn--close{
                top: -48px;
                right: 0;
                color: @primary-color;
                border-color: #fff;
                &:hover{
                border-color: #fff;
                }
            }
        }

        &__header {
            font-size: 24px;
            font-weight: 400;
            line-height: 32px;
            color: #51458B;
        }

        &__body {
            height: calc(100vh - 112px);
            padding: 16px;
            overflow-y: auto;
        }

        &__form {
            margin-top: 40px;

            &__sub {
                margin-bottom: 20px;
            }

            & .ivu-form-item {
                margin-bottom: 0;
            }
            
            & .ivu-input {
                border-radius: 8px;
            }

            &__legend {
                margin-bottom: 4px;

                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                color: rgba(black, 0.54);
            }

            &__content .ivu-input {
                height: 224px;
                resize: none;
            }

            &__subject input {
                font-weight: 500;
                font-size: 14px;
                line-height: 16px;
                color: rgba(black, 0.87);
            }

            &__content input {
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
                color: rgba(black, 0.87);
            }

            &__receivers {
                // width: 976px;
                // height: 38px;
                padding: 6px 8px 2px 8px;
                border-radius: 8px;
                border: 1px solid rgba(black, 0.08);
                position: relative;
                flex-wrap: wrap;

                transition: border 0.2s ease-in-out;
                &:hover {
                    cursor: text;
                    border-color: @primary-color;
                }

                &__placeholder {
                    position: absolute;
                    top: 7px;
                    left: 9px;
                    margin-bottom: 4px;
                    user-select: none;
                    z-index: 0;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(black, 0.26);
                    line-height: 24px;
                }
                
                &__search {
                    position: absolute;
                    top: calc(100% + 4px);
                    left: 8px;
                    z-index: 1000;
                    width: 960px;
                    height: 168px;
                    overflow-y: auto;
                    border-radius: 8px;
                    background: white;
                    box-shadow: 0 24px 38px 3px rgba(black, 0.1), 0 9px 46px 8px rgba(black, 0.08), 0 11px 15px 0 rgba(black, 0.16);
                    border: 1px solid rgba(black, 0.08);
                    padding: 8px;

                    &__item {
                        width: 944px;
                        height: 48px;
                        border-radius: 8px;
                        padding: 8px 16px;

                        &:hover {
                            cursor: pointer;
                            background: rgba(black, 0.08);
                        }

                        &__phone {
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 16px;
                            color: rgba(black, 0.87);
                        }

                        &__other {
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 16px;
                            color: rgba(black, 0.54);
                        }
                    }
                }

                &__input {
                    height: 24px;
                    flex-grow: 1;
                    margin-bottom: 4px;
                    font-size: 14px;
                    line-height: 24px;
                    font-weight: 400;
                    color: rgba(black, 0.87);
                    z-index: 1;
                }
            }

            &__datepicker {
                width: 100%;

                & input {
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 16px;
                    color: rgba(0, 0, 0, 0.87);
                }
            }

            &__timepicker {
                width: 100%;

                & input {
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 16px;
                    color: rgba(0, 0, 0, 0.87);
                }
            }

            &__pushway {
                width: 944px;
                height: 56px;
                background-color: white;
                border: 1px solid rgba(black, 0.12);
                border-radius: 8px;
                padding: 8px 16px;

                transition: background-color 0.2s ease-in-out;

                &[active] {
                    background-color: rgba(134, 124, 233, 0.12);
                }

                &__text {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 40px;
                    color: rgba(black, 0.54);
                }


                &__icon {
                    height: 40px;
                    width: 40px;
                    padding: 8px;
                    border-radius: 50%;
                    background: rgba(black, 0.08);
                }
            }
        }

        
    }
</style>